import { createFileRoute, Link, useRouterState } from "@tanstack/react-router"
import { SettingsShell } from "@/components/settings-shell"
import { Skeleton } from "@/components/ui/skeleton"
import { useCompanyCapabilities } from "@/lib/company-capabilities"

const RECRUIT_SETTINGS_NAV = [
  { to: "/recruit/settings/account", label: "Account" },
  { to: "/recruit/settings/company", label: "Company" },
  { to: "/recruit/settings/team", label: "Team" },
  { to: "/recruit/settings/support", label: "Support" },
] as const

export const Route = createFileRoute("/recruit/settings")({
  component: RecruitSettingsLayout,
})

function RecruitSettingsLayout() {
  const pathname = useRouterState({ select: (state) => state.location.pathname })
  const capabilities = useCompanyCapabilities()
  const needsCompanyManagement =
    pathname.startsWith("/recruit/settings/company") ||
    pathname.startsWith("/recruit/settings/team")

  if (needsCompanyManagement && capabilities === undefined) {
    return <Skeleton className="h-48 w-full" />
  }
  if (
    needsCompanyManagement &&
    !(pathname.includes("/team")
      ? capabilities?.manageTeam
      : capabilities?.manageCompany)
  ) {
    return (
      <div className="mkt-panel mkt-panel--wash mx-auto max-w-xl">
        <p className="mkt-panel__title">Manager access required</p>
        <p className="mkt-panel__copy">
          Company and team settings are managed by an owner or admin.
        </p>
        <Link
          to="/recruit/settings/account"
          className="home-wf-btn home-wf-btn--outline mt-4"
        >
          Account settings
        </Link>
      </div>
    )
  }

  const items = RECRUIT_SETTINGS_NAV.filter((item) => {
    if (item.to.endsWith("/company")) return capabilities?.manageCompany === true
    if (item.to.endsWith("/team")) return capabilities?.manageTeam === true
    return true
  })
  return <SettingsShell items={[...items]} />
}
